import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { AdvertService } from '@services/advert.service';
import { takeUntil } from 'rxjs';
import { UnSubscriptionDirective } from '@directives/unsubscribe.directive';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';
import { MessageBoxComponent } from '@akelius/angular-ui-kit';
import { TranslateModule } from '@ngx-translate/core';

export interface IReservationModalArgs {
    isReserved: boolean;
    advertId: string;
}

@Component({
    selector: 'reservation',
    templateUrl: 'reservation.component.html',
    styleUrls: ['reservation.component.less'],
    imports: [MatIconButton, MatDialogClose, MatIcon, LoadingIndicatorComponent, MessageBoxComponent, MatButton, TranslateModule]
})
export class ReservationComponent extends UnSubscriptionDirective implements OnInit {
    private advertService = inject(AdvertService);
    dialogRef = inject<MatDialogRef<ReservationComponent>>(MatDialogRef);
    args = inject<IReservationModalArgs>(MAT_DIALOG_DATA);

    currentViewType: 'loading' | 'finish' = 'loading';
    isSuccess: boolean = false;

    get isLoading(): boolean {
        return this.currentViewType === 'loading';
    }

    get messageKey(): string {
        const tag = this.isSuccess
            ? this.args.isReserved
                ? 'SHARED_COMPONENT.RESERVATION_CANCELLED_SUCCESS'
                : 'SHARED_COMPONENT.RESERVATION_SUCCESS'
            : 'SHARED_COMPONENT.RESERVATION_ERROR';
        return tag;
    }

    get warningBoxType() {
        return this.isSuccess ? 'success' : 'error';
    }

    ngOnInit(): void {
        this.isSuccess = false;
        this.advertService
            .patchAdvertFragment(this.args.advertId, { isReserved: !this.args.isReserved })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                () => this.reservationSucess(),
                () => this.reservationError(),
            );
    }

    private reservationSucess(): void {
        this.currentViewType = 'finish';
        this.isSuccess = true;
    }

    private reservationError(): void {
        this.currentViewType = 'finish';
    }
}
